import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from './icons/icon-subset';

import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';


@Component({
    selector: 'app-root',
    template: '<router-outlet />',
    standalone: true,
    imports: [RouterOutlet]
})

export class AppComponent implements OnInit {
    get isLoggedIn(): boolean {
        return true;
    }

    getCurrentRoute(): string {
        const segments = this.route.snapshot.url;
        const routePath = segments.map(segment => segment.path).join('/');

        return routePath;
    }

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private iconSetService: IconSetService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {

        this.iconSetService.icons = { ...iconSubset };
    }

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            console.log("logged");
            const value = this.getCurrentRoute();
            console.log(value)

            if (this.isLoggedIn) {

            }
            this.router.events.subscribe((evt) => {
                if (!(evt instanceof NavigationEnd)) {
                    return;
                }
            });
        }
    }
}
